import { formatHtml } from "@trumpf/ux.common-storybook";
import {
    dummyDownload,
    TeaserDownloadTemplate,
    TeaserDownloadListTemplate,
    TeaserDownloadDocumentTemplate,
    TeaserDownloadDocumentListTemplate,
} from "./teaser-download.templates";

export default {
    title: "Website/Partial Templates/Teaser/Download",
    render: TeaserDownloadTemplate.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: { ...dummyDownload },
};

export const Default = {};

export const List = {
    render: TeaserDownloadListTemplate.bind({}),
};

export const Document = {
    render: TeaserDownloadDocumentTemplate.bind({}),
    args: {
        withImage: true,
    },
    argTypes: {
        control: { type: "boolean" },
    },
};

export const DocumentList = {
    render: TeaserDownloadDocumentListTemplate.bind({}),
    args: {
        withImage: true,
        listView: "column",
    },
    argTypes: {
        control: { type: "boolean" },
        listView: {
            control: { type: "radio" },
            options: ["column", "row"],
        },
    },
};
